import React, { useState } from "react";

const LifestyleSelector = ({ categories, selected, setSelected }) => {
  const [noteInput, setNoteInput] = useState({});
  const [editing, setEditing] = useState({});
  const [selectedFactor, setSelectedFactor] = useState("");
  const factors = Array.isArray(categories) ? categories : [];

  return (
    <div className="tw-mb-6">
      <h3 className="tw-block tw-mb-2">Lifestyle Factors</h3>
      <div className="tw-relative tw-mb-2">
        <select
          className="tw-w-full tw-border tw-rounded-lg tw-w-full tw-p-4 dark:tw-bg-black tw-p-2 tw-mb-2"
          value={selectedFactor}
          onChange={(e) => setSelectedFactor(e.target.value)}
          style={{
            WebkitAppearance: "none",
            MozAppearance: "textfield",
          }}
        >
          <option value="">Select a factor</option>
          {factors.map((f) => (
            <option key={f.value} value={f.value}>
              {f.label}
            </option>
          ))}
        </select>
        <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pr-4">
          <svg
            className="tw-w-4 tw-h-4 tw-text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>

      {factors.map((f) =>
        selectedFactor === f.value || editing[f.value] ? (
          <div key={f.value} className="tw-mb-4">
            <div className="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mb-2">
              <textarea
                value={noteInput[f.value] || selected[f.value] || ""}
                onChange={(e) =>
                  setNoteInput({ ...noteInput, [f.value]: e.target.value })
                }
                className="tw-w-full tw-border tw-rounded-lg tw-p-4"
                placeholder={f.placeholder}
                rows={2}
              />
              <div className="tw-flex">
                <button
                  type="button"
                  onClick={() => {
                    if (noteInput[f.value]?.trim()) {
                      setSelected({
                        ...selected,
                        [f.value]: noteInput[f.value].trim(),
                      });
                      setEditing({ ...editing, [f.value]: false });
                      setNoteInput({ ...noteInput, [f.value]: "" });
                      setSelectedFactor("");
                    }
                  }}
                  className="tw-px-2 w-min-w-[90px] tw-text-sm tw-text-green-600 hover:tw-underline"
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => {
                    const newSelected = { ...selected };
                    delete newSelected[f.value];
                    setSelectedFactor("");
                    setEditing({ ...editing, [f.value]: false });
                    setNoteInput({ ...noteInput, [f.value]: "" });
                  }}
                  className="tw-ml-2 tw-text-sm tw-text-gray-500 hover:tw-text-red-500 tw-min-h-[44px] tw-min-w-[44px] tw-flex tw-items-center tw-justify-center"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        ) : null
      )}

      {factors.map((f) =>
        selected[f.value] && !editing[f.value] && selectedFactor !== f.value ? (
          <div key={f.value} className="tw-mb-6">
            <label className="tw-block tw-font-semibold">{f.label}</label>
            <div className="tw-flex tw-justify-between tw-items-center tw-mt-2 tw-bg-gray-100 tw-rounded-xl tw-py-4 tw-pl-6 tw-pr-1">
              <div className="tw-text-sm tw-w-full">{selected[f.value]}</div>
              <div className="tw-flex tw-items-center">
                <button
                  type="button"
                  onClick={() => setEditing({ ...editing, [f.value]: true })}
                  className="tw-ml-4 tw-text-sm tw-text-blue-600 hover:tw-underline"
                >
                  Edit
                </button>
                <button
                  type="button"
                  onClick={() => {
                    const newSelected = { ...selected };
                    delete newSelected[f.value];
                    setSelected(newSelected);
                    setEditing({ ...editing, [f.value]: false });
                    setNoteInput({ ...noteInput, [f.value]: "" });
                  }}
                  className="tw-ml-2 tw-text-sm tw-text-gray-500 hover:tw-text-red-500 tw-min-h-[44px] tw-min-w-[44px] tw-flex tw-items-center tw-justify-center"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        ) : null
      )}
    </div>
  );
};

export default LifestyleSelector;
